(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.legacy', {
            parent: 'public.online',
            url: '/reservation/legacy/:locationId',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.legacy': {
                    templateUrl: 'app/public/online/reservation/legacy/create.html',
                    controller: 'OnlineCreateLegacyController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.legacy': {},
                'topnavbar@public.online.legacy': {}
            },
            params: {
            },

            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
